// var environment = 'staging';
var environment = 'production';
if(window.location.hostname == 'localhost'){
    environment = 'development';
}else if (window.location.hostname.indexOf('staging') > -1) {
    // environment = 'production';
    environment = 'staging';
}else{
    environment = 'production';
    // environment = 'staging';
}
console.log("environment ::: ", environment);
const ENV = environment;
const config = {};

config.production = {
    db: "miami-odoo15",
    path: "https://martech-api-us.apachedigital.io/",
    // dbfilter: "dev_tatanka"
};

config.staging = {
    // db: "tatanka-staging-v3",
    db: "miami-odoo15",
    path: "https://martech-api-us.apachedigital.io/",
    // "X-Odoo-dbfilter": "tatanka-staging-v3",
    // "X-Odoo-dbfilter": "staging",
    // "Sec-Fetch-Dest": 'empty',
    // "Sec-Fetch-Mode": 'cors',
    // "Sec-Fetch-Site": 'same-site',
    // "dbfilter": "staging"
    // dbfilter: "dev_tatanka"
    // "x-odoo-dbfilter": "tatanka-staging-v3"
};

config.development = {

  db: "miami-odoo15",
  path: "https://martech-api-us.apachedigital.io/",

  // db: "tatanka_staging",
  // db: "odoo15-staging",
  // path: "https://martech-api-staging.apachedigital.io/",
  // path: "https://tatanka.apachedigital.io/",
  // dbfilter: "apachev1"
  // dbfilter: "dev_tatanka"
};



export const Config = {
  db:config[ENV].db,
  path:config[ENV].path,
  dbfilter:config[ENV].dbfilter
}
